import {Router} from '@angular/router';
import {SessionGuard} from './session.guard';
import {SessionService} from './session.service';
import {RoleService} from "./role.service";

export * from './session.guard';
export * from './session.service';
export * from './role.service';
export * from './roles.tabs.guard';
export * from './permission-routes';

export const SESSION_SECURITY_PROVIDERS = [
    RoleService,
    SessionService,
    {
        provide: SessionGuard,
        useClass: SessionGuard,
        deps: [Router, SessionService, RoleService]
    }
];


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/core/security/index.ts